import { Routes, Route } from 'react-router-dom'
import routes from 'routes'
import OnboardingSelector from 'layouts/onboarding/components/onboardingselector'
import { Onboarding } from 'layouts/onboarding'

//Onboarding Components
import RetirementGoals from './components/RetirementGoals'
import TellUsAboutYourself from './components/TellUsAboutYourself'

import { useContext } from 'react'
import { IntakeContext } from 'context/IntakeContext'

export const AppRoutes = () => {
  const { isAdmin, isAgency } = useContext(IntakeContext)

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse)
      }

      if (!route.route) {
        return null
      }

      if (route.requiresAdmin && !isAdmin) {
        return null
      }

      // if (route.requiresAgency && !isAgency) {
      //   return null
      // }

      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
        />
      )
    })
  return (
    <Routes>
      <Route path="/">
        {getRoutes(routes)}
        <Route index element={<OnboardingSelector />} />
        <Route path="retirement-goals" element={<RetirementGoals />} />
        <Route path="onboarding" element={<OnboardingSelector />} />
        <Route path="onboarding-full" element={<Onboarding />} />
        <Route path="about-yourself" element={<TellUsAboutYourself />} />
      </Route>
    </Routes>
  )
}
